import { IntakeSectionHeader } from "@/common/styles";
import { Col, Form, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";
import Select from "@/common/elements/InputElements/Select";
import CommonDatePicker from "@/common/elements/DatePicker";

// Mirrors ASP's HandleReleaseReason (DetentionsInterface.asp:332-372) /
// RefListItemConstants.vbs:1604-1609 - which of the three "Released to"
// fields shows is driven by the specific Release Reason selected, and
// they're mutually exclusive (only one shows at a time).
const RELEASEREASON_RELEASETOAUTHORITY = 54240015;
const RELEASEREASON_RELEASETOFACILITY = 54240016;
const RELEASEREASON_RELEASETOSTATE = 54240017;

const ReleaseInformation = ({
  arrestReport = {},
  form,
  disabled,
  startingPoint = "",
}) => {
  const releaseReasonId = Form.useWatch(
    ["detentionsArrestReports", 0, "releaseReasonId"],
    form
  );

  return (
    <section>
      <IntakeSectionHeader>
        <span>Release Information</span>
      </IntakeSectionHeader>

      <FieldSecurityProvider
        entity="DetentionsArrestReports"
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <FormContainer>
          <Row gutter={16}>

            {/* Release Date & Time */}
            <Col span={8}>
              <SecureFormItem
                fieldName="releaseDateTime"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "releaseDateTime"],
                  label: "Release Date & Time",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime
                />
              </SecureFormItem>
            </Col>

            {/* Release Reason */}
            <Col span={12}>
              <SecureFormItem
                fieldName="releaseReasonId"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "releaseReasonId"],
                  label: "Release Reason",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList("Release_Reason", false, false, true)}
                  onChange={() => setTimeout(() => document.activeElement.blur(), 0)}
                  placeholder="Release Reason"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

          </Row>

          {/* "Released to" — mutually exclusive, shown only for the
              matching Release Reason (see HandleReleaseReason above). */}
          {releaseReasonId === RELEASEREASON_RELEASETOFACILITY && (
            <Row gutter={16}>
              <Col span={12}>
                <SecureFormItem
                  fieldName="releaseToFacilityId"
                  formItemProps={{
                    name: ["detentionsArrestReports", 0, "releaseToFacilityId"],
                    label: "Released to (Facility)",
                    layout: "vertical",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("Release_to_Facility", false, false, true)}
                    placeholder="Released to (Facility)"
                    showSearch
                    variant="outlined"
                  />
                </SecureFormItem>
              </Col>
            </Row>
          )}

          {releaseReasonId === RELEASEREASON_RELEASETOSTATE && (
            <Row gutter={16}>
              <Col span={12}>
                <SecureFormItem
                  fieldName="releaseToState"
                  formItemProps={{
                    name: ["detentionsArrestReports", 0, "releaseToState"],
                    label: "Released to (State)",
                    layout: "vertical",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("USState")}
                    placeholder="Released to (State)"
                    showSearch
                    variant="outlined"
                  />
                </SecureFormItem>
              </Col>
            </Row>
          )}

          {releaseReasonId === RELEASEREASON_RELEASETOAUTHORITY && (
            <Row gutter={16}>
              <Col span={12}>
                <SecureFormItem
                  fieldName="releaseToAuthorityId"
                  formItemProps={{
                    name: ["detentionsArrestReports", 0, "releaseToAuthorityId"],
                    label: "Released to (Authority)",
                    layout: "vertical",
                  }}
                >
                  <Select
                    options={getOptionsFromRefList("Release_to_Authority", false, false, true)}
                    placeholder="Released to (Authority)"
                    showSearch
                    variant="outlined"
                  />
                </SecureFormItem>
              </Col>
            </Row>
          )}
        </FormContainer>
      </FieldSecurityProvider>
    </section>
  );
};

export default ReleaseInformation;